if (!customElements.get('slider-with-filters')) {
  class SliderWithFilters extends HTMLElement {
    ALL_COLLECTIONS_FILTER = 'All Collections';

    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1.11,
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.09,
          spaceBetween: 24,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
      this.querySelectorAll('[js-category-filter]').forEach((filter) =>
        filter.addEventListener('click', this.onFilterClick.bind(this)),
      );
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }

    /**
     * On filter click.
     *
     * @param {Event} event
     */
    onFilterClick(event) {
      this.querySelector('[js-category-filter].active').classList.remove(
        'active',
      );
      event.target.classList.add('active');
      this.filterSlides(event.target.getAttribute('js-category-filter'));
      this.slider.update();
      this.slider.slideTo(0);
    }

    /**
     * Filter slides.
     *
     * @param {String} filter
     */
    filterSlides(filter) {
      this.querySelectorAll('[js-category-slide]').forEach((slide) => {
        const shouldBeHidden =
          slide.getAttribute('js-category-slide') !== filter &&
          filter !== this.ALL_COLLECTIONS_FILTER;

        slide.classList.toggle('hidden', shouldBeHidden);
      });
    }
  }
  customElements.define('slider-with-filters', SliderWithFilters);
}
